// extracted by mini-css-extract-plugin
export default {"functions":"main-page_functions__LnwX7","wordLists":"main-page_wordLists__LEI1+","lists":"main-page_lists__kfSW5"};